import { setTimeout } from "timers";

jQuery(document).ready(function() {

  $('#toggleNavbar').on('click', function() {
    $('#header').toggleClass('open-menu-mobile');
  });

  ////////////////////////////////////
  var executeAnimate = false;
  var intViewportHeight;
  var intViewportWidth;

  if ($("#lista-questoes").length > 0) {
    $("#btn-ver-mais").click(function() {
      $("#lista-questoes").removeClass("reduzido");
      $("#detalhe-questao").addClass("hidden");
    });
  }

  $("#close").click(function() {
    $(".atentionMenu").attr("style", "display: none");
    $(".headerLogo").attr("style", "margin: 70px 0 0");
  });

  var list = $(".menuAnos__links");
  var listItems = list.children("li");
  list.append(listItems.get().reverse());

  $("#arrowDown").click(function() {
    $(".menuAnos__links").toggle();
    $("#arrowDown i").toggleClass("rotate");
  });

  $(".menuProva__select").click(function() {
    $(".menuProva").toggleClass("closed");
  });


  $(".englishPart").click(function() {
    $(".englishPart__boxQuestion").toggleClass("closed");
    $(".englishPart").toggleClass("rotate");
  });
  $(".spanishPart").click(function() {
    $(".spanishPart__boxQuestion").toggleClass("closed");
    $(".spanishPart").toggleClass("rotate");
  });
  $(".firstPart").click(function() {
    $(".firstPart__boxQuestion").toggleClass("closed");
    $(".firstPart").toggleClass("rotate");
  });
  $(".secondPart").click(function() {
    $(".secondPart__boxQuestion").toggleClass("closed");
    $(".secondPart").toggleClass("rotate");
  });

  // Set Up da Página inicial = FULLDAY
  if ($("#app").hasClass("fullDay")) {
    // Remontando o HEADER
    $(".headerLogo > img").attr("style", "display: block");
    $(".headerLogo > a").attr("style", "display: none");

    // Provas Home setup
    $(".header-home").removeClass("reduzido");
    $("#switch-dias-provas").addClass("upper-home");
    $("#lista-provas").attr("style", "display: none");

    // BTN DIA setup
    let dia = $(".btn-dia").data("dia");
    $(".btn-dia").removeClass("active");
    $(".col-xs-6").removeClass("active");
    $(".col-xs-6").removeClass("noDay");

    $(".slider-provas").removeClass("active");

    $("#videos-comentarios-gerais").attr("style", "display: none");

    $(".col-xs-6")
      .not(".active")
      .css("display", "block");

    $(".slider-provas").addClass("destaque");
  }

  if ($("#videos-comentarios-gerais").length > 0) {
    $(".item-video-comentario").each(function() {
      if ($(this).find(".embed-video iframe").length > 0) {
        var url = $(this).find(".embed-video iframe")[0].src;
        if (url.indexOf("youtube") >= 0) {
          var url = url.replace("&autoplay=1", "");
          $(this).find(".embed-video iframe")[0].src = url;
        }
      }
    });
  }

  if ($("#detalhe-questao").length > 0) {
    $("#thumb-video").click(function() {
      $(this).addClass("hidden");
      $(this)
        .closest("#video-questao")
        .find("iframe")[0].src += "&autoplay=1";
      return false;
    });
  }
});
